export default function ({
  headers = [],
  options = {},
  search = {},
  headersDictionary = {},
  draw = 0,
} = {}) {
  const body = {};

  body.draw = draw;

  body.columns = headers.map(header => ({
    data: header.data || headersDictionary[header.value] || header.value,
    name: header.name || '',
    orderable: typeof header.sortable !== 'undefined' ? header.sortable : true,
    searchable: typeof header.searchable !== 'undefined' ? header.searchable : (!!search[header.value]),
    ...(
      search[header.value]
        ? {
          search: {
            regex: !!header.regex,
            value: search[header.value]
          }
        }
        : {}
    ),
  }));

  const sortBy = options.sortBy || [];
  const sortDesc = options.sortDesc || [];

  body.order = sortBy.map((sortHeaderValue, sortHeaderIndex) => ({
    column: headers.findIndex(i => i.value === sortHeaderValue),
    dir: sortDesc[sortHeaderIndex] ? 'desc' : 'asc',
  }));

  options.page = Number(options.page) || 0;
  options.itemsPerPage = Number(options.itemsPerPage) || 0;

  body.start = ((options.page - 1) * options.itemsPerPage) + 0;
  body.length = options.itemsPerPage;

  if (search.commonSearch) {
    body.search = {
      regex: false,
      value: search.commonSearch,
    };
  }

  return body;
}
